import { get, set } from './common';
import { add } from 'date-fns';
var ProducerAvatarCacheKey = 'producerAvatarCache:typica';
export var setProducerAvatar = function (url, avatarUrl) {
    var cache = get(ProducerAvatarCacheKey) || {};
    var expiry = add(new Date(), { days: 1 }).valueOf();
    cache[url] = { url: avatarUrl, expiry: expiry };
    set(ProducerAvatarCacheKey, cache);
};
export var getProducerAvatar = function (url) {
    var cache = get(ProducerAvatarCacheKey);
    if (!cache)
        return;
    if (!cache[url])
        return;
    var now = new Date().valueOf();
    if (cache[url]['expiry'] < now)
        return;
    return cache[url]['url'];
};
